var _g, _path, _path2, _g2, _g3, _g4, _g5, _path3, _circle, _circle2, _circle3, _circle4, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 167,
    viewBox: "0 0 201 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_834_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7717 135.673C21.766 134.171 21.0434 132.464 20.6801 130.627L21.4158 130.481C21.2504 129.645 21.1636 128.78 21.1636 127.895V125.445H20.4136V120.545H21.1636V115.645H20.4136V110.745H21.1636V105.845H20.4136V100.945H21.1636V96.0445H20.4136V91.1445H21.1636V86.2445H20.4136V81.3445H21.1636V78.8945C21.1636 78.0087 21.2504 77.1438 21.4158 76.3078L20.6801 76.1623C21.0434 74.3255 21.766 72.618 22.7717 71.1159L23.3949 71.5332C24.3625 70.0879 25.6069 68.8434 27.0522 67.8758L26.635 67.2526C28.137 66.247 29.8446 65.5244 31.6813 65.161L31.8269 65.8967C32.6629 65.7314 33.5277 65.6445 34.4136 65.6445H36.9493V64.8945H42.0207V65.6445H47.0921V64.8945H52.1636V65.6445H57.235V64.8945H62.3064V65.6445H67.3779V64.8945H72.4493V65.6445H77.5207V64.8945H82.5921V65.6445H87.6636V64.8945H92.735V65.6445H97.8064V64.8945H102.878V65.6445H105.414C106.299 65.6445 107.164 65.7314 108 65.8967L108.146 65.161C109.983 65.5244 111.69 66.247 113.192 67.2526L112.775 67.8758C114.22 68.8434 115.465 70.0879 116.432 71.5332L117.055 71.1159C118.061 72.618 118.784 74.3255 119.147 76.1623L118.411 76.3078C118.577 77.1438 118.664 78.0087 118.664 78.8945V81.3445H119.414V86.2445H118.664V91.1445H119.414V96.0445H118.664V100.945H119.414V105.845H118.664V110.745H119.414V115.645H118.664V120.545H119.414V125.445H118.664V127.895C118.664 128.78 118.577 129.645 118.411 130.481L119.147 130.627C118.784 132.464 118.061 134.171 117.055 135.673L116.432 135.256C115.465 136.701 114.22 137.946 112.775 138.913L113.192 139.536C111.69 140.542 109.983 141.265 108.146 141.628L108 140.892C107.164 141.058 106.299 141.145 105.414 141.145H102.878V141.895H97.8064V141.145H92.735V141.895H87.6636V141.145H82.5922V141.895H77.5207V141.145H72.4493V141.895H67.3779V141.145H62.3064V141.895H57.235V141.145H52.1636V141.895H47.0921V141.145H42.0207V141.895H36.9493V141.145H34.4136C33.5277 141.145 32.6629 141.058 31.8269 140.892L31.6813 141.628C29.8446 141.265 28.137 140.542 26.635 139.536L27.0522 138.913C25.6069 137.946 24.3625 136.701 23.3949 135.256L22.7717 135.673Z",
    stroke: "#DDE8ED",
    strokeWidth: 1.5,
    strokeDasharray: "5 5",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.414 64.8945C158.414 60.4763 161.995 56.8945 166.414 56.8945H192.414C196.832 56.8945 200.414 60.4763 200.414 64.8945V86.8945C200.414 91.3128 196.832 94.8945 192.414 94.8945H166.414C161.995 94.8945 158.414 91.3128 158.414 86.8945V64.8945Z",
    fill: "#DFE9ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.413574 57.8945C0.413574 51.2671 5.78616 45.8945 12.4136 45.8945H79.4136C86.041 45.8945 91.4136 51.2671 91.4136 57.8945V107.895C91.4136 114.522 86.041 119.895 79.4136 119.895H12.4136C5.78616 119.895 0.413574 114.522 0.413574 107.895V57.8945Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.4136,
    y: 60.8945,
    width: 13,
    height: 47,
    rx: 1,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.4136,
    y: 60.8945,
    width: 13,
    height: 47,
    rx: 1,
    fill: "url(#paint0_linear_834_50)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.4136,
    y: 60.8945,
    width: 14,
    height: 47,
    rx: 1,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.4136,
    y: 60.8945,
    width: 14,
    height: 47,
    rx: 1,
    fill: "url(#paint1_linear_834_50)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.4136,
    y: 60.8945,
    width: 14,
    height: 47,
    rx: 1,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.4136,
    y: 60.8945,
    width: 14,
    height: 47,
    rx: 1,
    fill: "url(#paint2_linear_834_50)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.93
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.4136,
    y: 60.8945,
    width: 13,
    height: 47,
    rx: 1,
    fill: "#E7F2F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.4136,
    y: 60.8945,
    width: 13,
    height: 47,
    rx: 1,
    fill: "url(#paint3_linear_834_50)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9136 106.395L37.4136 78.3945L59.4136 93.3945L88.0108 50.8945L102.914 39.8945",
    stroke: "#4288F0",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4136,
    cy: 78.8945,
    r: 3,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.4136,
    cy: 92.8945,
    r: 3,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.4136,
    cy: 50.8945,
    r: 3,
    fill: "#4288F0",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 135.414,
    cy: 17.8945,
    r: 17,
    fill: "#62D294"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.694 19.9201L140.761 12.6329C141.153 12.2285 141.801 12.2277 142.195 12.6311L142.735 13.1852C143.113 13.573 143.113 14.1911 142.736 14.5797L134.412 23.1543C134.019 23.5593 133.369 23.5589 132.976 23.1533L129.089 19.1371C128.713 18.7485 128.714 18.1312 129.091 17.7438L129.629 17.1913C130.023 16.7869 130.674 16.7885 131.065 17.1948L133.694 19.9201Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_834_50",
    x: 0.413574,
    y: 49.8945,
    width: 139,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.117647 0 0 0 0 0.133333 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_834_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_834_50",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_834_50",
    x1: 19.9136,
    y1: 60.8945,
    x2: 19.9136,
    y2: 107.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_834_50",
    x1: 54.4136,
    y1: 60.8945,
    x2: 54.4136,
    y2: 107.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_834_50",
    x1: 37.4136,
    y1: 60.8945,
    x2: 37.4136,
    y2: 107.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_834_50",
    x1: 71.9136,
    y1: 60.8945,
    x2: 71.9136,
    y2: 107.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.50f621717fec41ca78e8f40439889a95.svg";
export { ForwardRef as ReactComponent };